import { render, staticRenderFns } from "./GroupTrendRank.vue?vue&type=template&id=79ece553&scoped=true"
import script from "./GroupTrendRank.vue?vue&type=script&lang=js"
export * from "./GroupTrendRank.vue?vue&type=script&lang=js"
import style0 from "./GroupTrendRank.vue?vue&type=style&index=0&id=79ece553&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ece553",
  null
  
)

export default component.exports